module.exports = __webpack_public_path__ + "img/auth2.1dafacc1.png";